module.exports = __webpack_public_path__ + "img/jf_home_11.cd3ff4f3.jpg";